/* global successPanel, errorPanel */

import React from 'react'
import PropTypes from 'prop-types'
import Base from './Base'
import { api } from 'components/api'
import { supplierCommoditiesPath } from 'components/routes/path'

const Wrapper = ({ supplierId }) => {
  const headers = {
    Accept: 'application/json'
  }

  return (
    <Base
      supplierId={supplierId}
      handleSave={(commodityClassIds) => {
        api.postWithCsrf({
          url: supplierCommoditiesPath(supplierId),
          headers,
          data: {
            ids: commodityClassIds
          }
        }).then((response) => {
          if (response.status === 200) {
            successPanel('UNSPSC selections saved')
          } else {
            errorPanel('There was an error saving your selections')
          }
        })
      }}
    />
  )
}

Wrapper.propTypes = {
  supplierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  csrfToken: PropTypes.string
}

Wrapper.defaultProps = {
  csrfToken: null
}

export default Wrapper
